const commonAbbrs = {
  road: 'rd',
  street: 'st',
  lane: 'ln',
  avenue: 'ave',
  boulevard: 'blvd',
  drive: 'dr',
  north: 'n',
  south: 's',
  east: 'e',
  west: 'w',
  suite: 'ste',
};

function normalizeString(str) {
  if (!str) {
    return '';
  }

  let newStr = str.toLowerCase();
  newStr = newStr.replace(/[^a-zA-Z0-9]/g, '');

  Object.keys(commonAbbrs).forEach((k) => {
    newStr = newStr.replace(k, commonAbbrs[k]);
  });

  return newStr;
}

function normalizeAddress(addr) {
  return [
    addr.address,
    addr.address2,
    addr.address3,
    addr.city,
    addr.state,
    addr.zipcode && addr.zipcode.substr(0, 5),
  ]
    .map(normalizeString)
    .join(':::');
}

export default function dedupeAddresses(addrs) {
  const dupes = {};

  return addrs.filter((addr) => {
    const normalized = normalizeAddress(addr);
    const didExist = dupes[normalized] || false;

    dupes[normalized] = true;

    return !didExist;
  });
}
